<template>
  <div class="base-radio-box">
    <label>
      <BaseIcon :name="iconName"></BaseIcon>
      <input type="radio" :name="name" :value="optionValue" :checked="checked" v-on="listeners"/>
      <p><slot></slot></p>
    </label>
  </div>
</template>

<script>
  import { omit } from 'lodash'
  
  const CUSTOM_EVENTS = {
    input: 'input'
  }

  export default {
    props: {
      optionValue: String,
      value: String,
      name: {
        type: String,
        required: true
      }
    },
    computed: {
      listeners () {
        const filteredListeners = omit(this.$listeners, Object.values(CUSTOM_EVENTS))

        return {
          ...filteredListeners,
          change: e => this.$emit(CUSTOM_EVENTS.input, e.target.value)
        }
      },
      checked () {
        return this.optionValue === this.value
      },
      iconName () {
        return this.checked ? 'radio-selected' : 'radio-unselected'
      }
    },
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';

  .base-radio-box {

    label {
      display: inline-flex;
      align-items: center;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
        margin-right: 9px;
      }

      p {
        font-size: 14.6px;
        line-height: 28px;
      }
    }

    input {
      &:focus + label {
        outline: 2px solid $color-purple;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseRadioBox.vue